import LogsTable from './LogsTable';

export default LogsTable;


// WEBPACK FOOTER //
// ./src/features/log/components/logs-table/index.js